import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SharedService } from '../services/shared.service';

@Injectable()
export class WelcomeResolver implements Resolve<any> {

   constructor(public sharedService: SharedService) { }

   resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
        return this.sharedService.getWelcomeContent().pipe(
            catchError((error) => {
                return EMPTY;
            })
        )
   }
}